import React, { useEffect, useState } from "react";
import {
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Tooltip,
} from "@mui/material";
import Card from "@mui/material/Card";
// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
// Vision UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Data
import VuiButton from "components/VuiButton";
import { FaInfoCircle, FaPlus } from "react-icons/fa";
import AddNewClientDialog from "./components/AddNewClientDialog";
import useCommon from "hooks/useCommon";
import { getUsers } from "store/slice/userSlice";
import { getUserInfo } from "store/slice/userSlice";
import ClientsTable from "./components/ClientTable";
import { createClient } from "store/slice/clientSlice";
import Snackbar from "components/Snackbar";
import { resetCreateAdminState } from "store/slice/clientSlice";
import VuiInput from "components/VuiInput";

const createEmptyHotel = () => ({
  name: "",
  address: "",
  timezone: "",
  defaultPhoneNumber: "8583510222",
  defaultEmail: "innovation@stayorli.com",
  identifierMode: "phone",
  countryCode: "+1",
  brandLogo: {
    contentType: "",
    dataBase64: "",
  },
});

const Clients = () => {
  const { STORE, DISPATCH } = useCommon();

  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contactNumber: "",
    hotels: [createEmptyHotel()],
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    color: "success",
    title: "",
    content: "",
    icon: "check",
  });

  const showSnackbar = ({ color, title, content, icon = "check" }) => {
    setSnackbar({
      show: true,
      color,
      title,
      content,
      icon,
    });
  };

  const closeSnackbar = () => setSnackbar((prev) => ({ ...prev, show: false }));

  const defaultFormData = {
    name: "",
    email: "",
    contactNumber: "",
    hotels: [createEmptyHotel()],
  };

  const handleOpenAddClient = () => {
    setOpen(true);
  };

  const handleCloseAddClient = () => {
    setFormData(defaultFormData);
    setOpen(false);
    DISPATCH(resetCreateAdminState());
  };
  const handleCreateClient = async (data) => {
    const cleanedPayload = {
      ...data,
      hotels: data.hotels.map((hotel) => {
        const cleanedHotel = { ...hotel };

        if (!cleanedHotel.brandLogo || !cleanedHotel.brandLogo.dataBase64) {
          delete cleanedHotel.brandLogo;
        }

        return cleanedHotel;
      }),
    };

    await DISPATCH(createClient(cleanedPayload))
      .unwrap()
      .then((res) => {
        const success = res?.success;

        if (success) {
          setFormData(defaultFormData);
          setOpen(false);
          DISPATCH(resetCreateAdminState());
          setSnackbar({
            ...snackbar,
            color: success ? "success" : "error",
            title: success ? "Client Added" : "Error",
            content: res?.message || "Client created successfully",
            icon: success ? "check" : "warning",
            show: true,
          });
        }
      })
      .catch((err) => {
        // setSnackbar({
        //   ...snackbar,
        //   color: "error",
        //   title: "Error",
        //   content: err?.message || "Failed to create client",
        //   icon: "warning",
        //   show: true,
        // });
      });
  };

  // useEffect(() => {
  //   DISPATCH(getClients());
  // }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox py={3}>
        <VuiBox mb={3}>
          <Card>
            <VuiBox
              display="flex"
              justifyContent="space-between"
              // alignItems="center"
              mb="22px"
              flexDirection={{ xs: "column", md: "row" }}
              alignItems={{ xs: "stretch", md: "center" }}
              gap={2}
            >
              <VuiTypography
                variant="lg"
                sx={{
                  width: { xs: "100%", md: "auto" },
                  textAlign: { xs: "left", md: "left" },
                }}
              >
                Clients Added
              </VuiTypography>

              <VuiBox display="flex" alignItems="center" gap={2}>
                <VuiBox width="220px">
                  <VuiInput
                    gradient
                    fullWidth
                    placeholder="Search clients..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </VuiBox>

                <VuiButton
                  variant="contained"
                  color="primary"
                  onClick={handleOpenAddClient}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    width: { md: "40%", xs: "50%" },
                  }}
                >
                  <FaPlus size={"12px"} />{" "}
                  <VuiTypography
                    variant="text"
                    color="white"
                    sx={{ display: { xs: "none", sm: "block" }, lineHeight: 1 }}
                  >
                    Add Client
                  </VuiTypography>
                </VuiButton>
              </VuiBox>
            </VuiBox>

            <VuiBox
              sx={{
                "& th": {
                  borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                    `${borderWidth[1]} solid ${grey[700]}`,
                },
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                      `${borderWidth[1]} solid ${grey[700]}`,
                  },
                },
              }}
            >
              {/* <Table columns={columns} rows={rows} /> */}
              <ClientsTable search={search} handleNotify={showSnackbar} />
            </VuiBox>
          </Card>
        </VuiBox>
      </VuiBox>

      <AddNewClientDialog
        open={open}
        setOpen={setOpen}
        formData={formData}
        setFormData={setFormData}
        onClose={handleCloseAddClient}
        onSubmit={(data) => {
          handleCreateClient(data);
        }}
      />

      <Snackbar
        color={snackbar.color}
        icon={snackbar.icon}
        title={snackbar.title}
        content={snackbar.content}
        open={snackbar.show}
        onClose={closeSnackbar}
        close={closeSnackbar}
      />

      {/* <EditClientDialog
        open={editOpen}
        clientId={editingId}
        onClose={() => {
          setEditOpen(false);
          setEditingId(null);
        }}
      /> */}
    </DashboardLayout>
  );
};

export default Clients;
